import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Persisted collapse state shared by every layout, so the side nav keeps the
// user's collapsed/expanded choice across route + layout changes (default ↔ full)
// AND across a full reload. `hasUserSet` records whether the user has ever toggled
// the nav — layouts consult it so a route default (see full-layout) only applies
// before the user has expressed a preference. Mirrors use-chat-widget-open.
type SideNavCollapsedState = {
  isCollapsed: boolean;
  hasUserSet: boolean;
  setCollapsed: (next: boolean) => void;
  setCollapsedDefault: (next: boolean) => void;
};

export const sideNavCollapsedStore = create<SideNavCollapsedState>()(
  persist(
    set => ({
      isCollapsed: false,
      hasUserSet: false,
      // A deliberate user toggle — records the preference so route defaults defer to it.
      setCollapsed: next => set({ isCollapsed: next, hasUserSet: true }),
      // A route's suggested default — ignored once the user has a preference.
      setCollapsedDefault: next => set(state => (state.hasUserSet ? state : { isCollapsed: next })),
    }),
    {
      name: 'dashboard.side-nav-collapsed',
      partialize: state => ({ isCollapsed: state.isCollapsed, hasUserSet: state.hasUserSet }),
    },
  ),
);

const useSideNavCollapsed = () => sideNavCollapsedStore();

export default useSideNavCollapsed;
